module.exports = __webpack_public_path__ + "1185b54d6f96328b190a59598f95f360.pdf";